import { useEffect, useMemo, useRef, useState } from "react";

interface FlipNumberProps {
	value: number,
	max: number,
}

const FlipNumber: React.FC<FlipNumberProps> = ({ value, max }) => {

	const [position, setPosition] = useState<'top' | 'bottom'>('bottom')
	const isInitialMount = useRef(true);
	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const mutationObserver = new MutationObserver(callBack)
		mutationObserver.observe(ref.current!, { attributes: true })
	}, [])

	useEffect(() => {
		if (!isInitialMount.current) {
			setPosition('top')
		}

		isInitialMount.current = false;

	}, [value])

	const callBack = (mutations: MutationRecord[]) => {
		mutations.forEach((mutation: MutationRecord) => {
			if (mutation.attributeName === 'class') {
				if ((mutation.target as any).className === 'flip-number-top') {
					setTimeout(() => {
						setPosition('bottom')
					}, 30)
				}
			}
		})
	}

	const flip = useMemo(() => {
		return <div className="flip-number-container" >
			<div ref={ref} className={position === 'bottom' ? 'flip-number-bottom' : 'flip-number-top'} >
				<div>{(value + 1) > max ? 0 : (value + 1)}</div>
				<div>{value}</div>
			</div>
		</div>
	}, [position, max, value]);

	return (flip);
}

export default FlipNumber;